import {
  GET_PLACES_MENU_ITEM,
  GET_PLACES_MENU_ITEM_FAILED,
  GET_PLACES_MENU_ITEM_SUCCESS,
  GET_SURVEY_SUCCESS,
  RESET_PLACES_MENU_ITEM,
} from "./actionTypes"

const INIT_STATE = {
  survey: [],
  placesMenuItem: null,
  loading: false,
}

const Places = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SURVEY_SUCCESS:
      return {
        ...state,
        survey: action.payload,
      }
    case GET_PLACES_MENU_ITEM:
      return {
        ...state,
        loading: true,
      }
    case GET_PLACES_MENU_ITEM_FAILED:
      return {
        ...state,
        loading: false,
      }
    case GET_PLACES_MENU_ITEM_SUCCESS:
      return {
        ...state,
        placesMenuItem: action.payload,
        loading: false,
      }
    case RESET_PLACES_MENU_ITEM:
      return {
        ...state,
        placesMenuItem: null,
      }
    default:
      return state
  }
}

export default Places
